import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterModule, RouterOutlet } from '@angular/router';
import { MessageService } from 'primeng/api';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';
import { Roles } from './shared/models/users/constants/roles';
import { user } from '@angular/fire/auth';
import { IsGrantedDirective } from './shared/directives/is-granted.directive';
import { IUser } from './shared/models/users/user.model';
import { UserProfileService } from './shared/services/user-profile.service';
import { UserService } from './app/pages/service/user.service';
import { RbacService } from './shared/services/rbac.service';


@Component({
    selector: 'app-root',
    standalone: true,
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [RouterModule, ToastModule, MessageModule],
})
export class AppComponent {
    currentUser!: IUser;
    constructor(
        private userService: UserService,
        private profileService: UserProfileService,
        private rbacService: RbacService
    ) {

        this.SetRoles();

        profileService.currentUser$.subscribe((user) => {
            if(user)
            this.rbacService.setAuthenticatedUser(user);
        });






    }

    async getAllUsers() {

        var users = await this.userService.getAllUsers();
        // console.log(users)
        return users;
    }

    async SetRoles() {
        this.rbacService.setRoles([
            {
                uid: Roles.USER,
                name: Roles.USER.toLowerCase(),
                extends: null
            },

            {
                uid: Roles.EMPLOYEE,
                name: Roles.EMPLOYEE.toLowerCase(),
                extends: null
            },
            {
                uid: Roles.ACCOUNTANT,
                name: Roles.ACCOUNTANT.toLowerCase(),
                extends: Roles.EMPLOYEE
            },
            {
                uid: Roles.HR,
                name: Roles.HR.toLowerCase(),
                extends: Roles.EMPLOYEE
            },
            {
                uid: Roles.MANAGER,
                name: Roles.MANAGER.toLowerCase(),
                extends: Roles.ACCOUNTANT
            },
            {
                uid: Roles.ADMIN,
                name: Roles.ADMIN.toLowerCase(),
                extends: Roles.MANAGER
            },
        ])
    }
}
